import React from "react"

import Message from "~components/Message"

const Variant = ({ variant, microcopy }) => (
  <Message size="small" noMargin>
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: microcopy.text(
          `messages.resource_variant_descriptions.${variant}`,
        ),
      }}
    />
  </Message>
)

export default Variant
